/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResetPasswordSendLinkInput
 */
export interface ResetPasswordSendLinkInput {
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordSendLinkInput
     */
    email?: string;
}

/**
 * Check if a given object implements the ResetPasswordSendLinkInput interface.
 */
export function instanceOfResetPasswordSendLinkInput(value: object): value is ResetPasswordSendLinkInput {
    return true;
}

export function ResetPasswordSendLinkInputFromJSON(json: any): ResetPasswordSendLinkInput {
    return ResetPasswordSendLinkInputFromJSONTyped(json, false);
}

export function ResetPasswordSendLinkInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResetPasswordSendLinkInput {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'] == null ? undefined : json['email'],
    };
}

export function ResetPasswordSendLinkInputToJSON(json: any): ResetPasswordSendLinkInput {
    return ResetPasswordSendLinkInputToJSONTyped(json, false);
}

export function ResetPasswordSendLinkInputToJSONTyped(value?: ResetPasswordSendLinkInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
    };
}

